module.exports = __webpack_public_path__ + "img/vueLogo.96e5850d.png";